'use strict';

var toastr = require('toastr');
var _ = require('lodash');
var tooltipTemplate = _.template(require('../templates/pooled-seasonality-inputdata-tooltip-template.html'));
var PooledSeasonalityInputDataChartController = function PooledSeasonalityInputDataChartController($scope, $rootScope, $timeout, $filter, inputDataRetrieverService, formatter, reviewConstants, seasonalityConstants) {
  var rmNumberFormat = $filter('rmNumberFormat');
  var rmMomentFormat = $filter('rmMomentFormat');
  $scope.filters = {};
  $scope.inputData = [];
  $scope.selectedBars = [];
  $scope.modifiedBars = [];
  $scope.chartRendered = false;
  $scope.showFilterModal = false;
  $scope.exclusionsChanged = false;
  $scope.disableExclusionToggle = false;
  $scope.showExclusionsModal = false;
  function dataFunction() {
    return $scope.inputData;
  }
  $scope.chartFormatters = {
    xAxisTickFormatter: formatter.momentWithYearTick('DAY_MONTH_SHORT_NAME_SHORT_YEAR', 'DAY_MONTH_SHORT_NAME', 'DAY_OF_MONTH', 'd1', dataFunction, true),
    yAxisTickFormatter: formatter.humanReadable,
    xAxisViewportFormatter: formatter.momentYearTick('YEAR', 'd1', dataFunction),
    tooltipFormatter: function tooltipFormatter(d) {
      return tooltipTemplate({
        departureDate: rmMomentFormat(d.d1, 'DATE_USER_SETTINGS'),
        m1: rmNumberFormat(d.m1, 'NUMBER'),
        m2: rmNumberFormat(d.m2, 'NUMBER'),
        eventType: d.eventType,
        m1fill: d.m1fill,
        m2fill: d.m2fill,
        excluded: d.excluded
      });
    }
  };
  $scope.chartFormatters.tooltipFormatter.cssClass = 'inputdata-chart-tooltip';
  $scope.isInactiveCalendar = function () {
    return $scope.displayedCalendar.calendarEntryStatus === seasonalityConstants.CALENDAR_STATUSES.INACTIVE;
  };
  $scope.disableExclusionToggle = $scope.isInactiveCalendar();
  $scope.$watch('screenState.flowType', redrawChart);
  $scope.getChartData = function (filterData) {
    inputDataRetrieverService.getInputChartData($scope.screenState.flowType, $scope.displayedCalendar, filterData).then(function (promises) {
      var chartAttributes = inputDataRetrieverService.transformData(promises, $scope.displayedCalendar, $scope.filters);
      $scope.inputData = chartAttributes.chartData;
      $scope.simpleLegend = chartAttributes.simpleLegend;
      $scope.staticLegend = chartAttributes.staticLegend;
      $scope.legend = chartAttributes.legend;
      $scope.renderChart(chartAttributes.chartData, chartAttributes.chartData.length);
      $scope.setInitialSelection(chartAttributes.chartData.length);
      $scope.chartRendered = true;
      if (chartAttributes.chartData.length === 0) {
        $scope.disableExclusionToggle = true;
      }
    })["catch"](function (e) {
      toastr.error('Error occured while retrieving Profile data', e);
    });
  };
  $scope.resetChart = function (event, filters) {
    if (filters) {
      $scope.filters = filters;
    }
    $scope.selectedBars = [];
    $scope.modifiedBars = [];
    $scope.exclusionsChanged = false;
    redrawChart();
  };
  function redrawChart() {
    $scope.showFilterModal = false;
    $scope.chartRendered = false;
    var filterData = $scope.filters;
    $scope.getChartData(filterData);
  }
  $scope.isExclusionToggleAllowed = function () {
    var selections = $scope.selectedBars;
    $timeout(function () {
      var noDataBars = _.filter(selections, function (selection) {
        return selection.isGap;
      });
      $scope.disableExclusionToggle = $scope.isInactiveCalendar() && noDataBars.length === 0;
    }, 10);
  };
  $scope.includeSelections = function () {
    var selections = $scope.selectedBars.length ? $scope.selectedBars : $scope.inputData;
    var modifiedData = _.chain(selections).filter(function (selection) {
      return selection.excluded && selection.eventType !== reviewConstants.EVENT_TYPE.EXCLUDED;
    }).reduce(function (modifiedBars, selection) {
      selection.overlay = undefined;
      selection.overlayViewport = undefined;
      selection.isRegularOutlier = false;
      selection.isMappedOutlier = false;
      selection.excluded = false;
      selection.o1 = 0;
      return modifiedBars.concat(selection);
    }, []).value();
    if (modifiedData && _.isArray(modifiedData) && modifiedData.length > 0) {
      $scope.inputData = _.union($scope.inputData, modifiedData);
      $scope.modifiedBars = _.union($scope.modifiedBars, modifiedData);
      $scope.updateChart();
      $scope.exclusionsChanged = true;
    }
  };
  $scope.excludeSelections = function () {
    var selections = $scope.selectedBars.length ? $scope.selectedBars : $scope.inputData;
    var modifiedData = _.chain(selections).filter(function (selection) {
      return !(selection.eventType === reviewConstants.EVENT_TYPE.EXCLUDED || selection.excluded);
    }).reduce(function (modifiedBars, selection) {
      selection.overlay = 'user-exclusion';
      selection.overlayViewport = 'user-exclusion-viewport';
      selection.isRegularOutlier = $scope.screenState.flowType === reviewConstants.FLOW_TYPE.REGULAR;
      selection.isMappedOutlier = $scope.screenState.flowType === reviewConstants.FLOW_TYPE.MAPPED;
      selection.excluded = true;
      selection.o1 = selection.m1 > selection.m2 ? selection.m1 : selection.m2;
      return modifiedBars.concat(selection);
    }, []).value();
    if (modifiedData && _.isArray(modifiedData) && modifiedData.length > 0) {
      $scope.inputData = _.union($scope.inputData, modifiedData);
      $scope.modifiedBars = _.union($scope.modifiedBars, modifiedData);
      $scope.updateChart();
      $scope.exclusionsChanged = true;
    }
  };
  $scope.goBack = function () {
    if ($scope.screenState.screenId === reviewConstants.SCREEN_ID_SEASONALITY) {
      $scope.$emit('pooled-seasonality:profile-review-complete', false);
    } else {
      $rootScope.$broadcast('demand-transparency:swap', false, $scope.defaultFilters.contextData);
    }
  };
  $scope.toggleFilterModal = function () {
    $scope.showFilterModal = !$scope.showFilterModal;
  };
  $scope.toggleExclusionModal = function () {
    $scope.showExclusionsModal = !$scope.showExclusionsModal;
  };
  $scope.saveExclusions = function (event, selectedOption) {
    $scope.showExclusionsModal = false;
    $scope.exclusionsChanged = false;
    var cabins = selectedOption === reviewConstants.OUTLIER_SAVE_OPTIONS.SELECTED ? [$scope.filters.selectedCabin] : $scope.inputCabins;
    var market = $scope.displayedCalendar.market.split('-');
    inputDataRetrieverService.saveOutliers(market, $scope.modifiedBars, cabins, $scope.filters.selectedDow).then(function (response) {
      $scope.modifiedBars = [];
      $scope.selectedBars = [];
      toastr.success('Data saved successfully');
    })["catch"](function (e) {
      toastr.error('Error occured while saving exclusions');
    });
  };
};
PooledSeasonalityInputDataChartController.$inject = ['$scope', '$rootScope', '$timeout', '$filter', 'InputDataChartDataService', 'FormatterService', 'PooledSeasonalityReviewConstants', 'SeasonalityConstants'];
module.exports = PooledSeasonalityInputDataChartController;